import { pathOr } from 'ramda';

import { IState } from '../../store';

export const getAgentName = (state: IState) => {
  return pathOr<string | null>(null, ['offerData', 'agent', 'name'], state);
};
